import { BoxStyleInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { observer } from 'mobx-react-lite';
import { ConfigurationStepId } from 'src/helpers/configurationSteps.helper';
import { StepCard } from '../StepCard';
import { StepCardProps } from '../StepCard.types';

export const BoxStyleCards = observer((props: StepCardProps<BoxStyleInfo>) => {
  const Component = StepCard<BoxStyleInfo>;
  return (
    <Component
      {...props}
      getIsSuggestedCard={card => card.code === props.cards[0].code}
      configurationStepId={ConfigurationStepId.BOX_STYLE}
    />
  );
});
